import { render, staticRenderFns } from "./DemoData.vue?vue&type=template&id=4a0f4d2a&"
import script from "./DemoData.vue?vue&type=script&lang=js&"
export * from "./DemoData.vue?vue&type=script&lang=js&"
import style0 from "./DemoData.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports